<template>
  <div class="flex flex-1 flex-col">
    <div class="flex flex-1 px-4 py-12">
      <section class="mx-auto w-full max-w-2xl space-y-6">
        <div class="space-y-2 text-center sm:text-left">
          <h1 class="text-3xl font-semibold text-slate-900">Muuda postitust</h1>
          <p class="text-sm text-slate-500">
            Uuenda või kustuta postituse sisu. Muudatused salvestuvad koheselt.
          </p>
        </div>

        <form
          @submit.prevent="updatePost"
          class="rounded-3xl border border-slate-200 bg-white p-6 shadow-xl shadow-slate-900/5 sm:p-8"
        >
          <div class="space-y-6">
            <div class="space-y-2">
              <label for="header" class="text-sm font-semibold text-slate-700">Pealkiri</label>
              <input
                id="header"
                type="text"
                name="header"
                v-model.trim="header"
                required
                class="w-full rounded-2xl border border-slate-200/80 bg-white px-4 py-3 text-sm text-slate-700 shadow-sm transition focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/30"
              />
            </div>

            <div class="space-y-2">
              <label for="content" class="text-sm font-semibold text-slate-700">Sisu</label>
              <textarea
                id="content"
                name="content"
                rows="6"
                v-model.trim="content"
                required
                class="w-full rounded-2xl border border-slate-200/80 bg-white px-4 py-3 text-sm text-slate-700 shadow-sm transition focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/30"
              ></textarea>
            </div>
          </div>

          <div class="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-end">
            <button
              type="submit"
              class="inline-flex w-full items-center justify-center rounded-xl bg-brand px-4 py-3 text-sm font-semibold uppercase tracking-wide text-white shadow-lg shadow-brand/20 transition hover:bg-brand-dark focus:outline-none focus:ring-4 focus:ring-brand/40 sm:w-auto"
            >
              Salvesta muudatused
            </button>
            <button
              type="button"
              @click="deletePost"
              class="inline-flex w-full items-center justify-center rounded-xl border border-red-200 px-4 py-3 text-sm font-semibold uppercase tracking-wide text-red-600 transition hover:bg-red-50 focus:outline-none focus:ring-4 focus:ring-red-200 sm:w-auto"
            >
              Kustuta postitus
            </button>
          </div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "SinglePost",
  data() {
    return {
      content: "", // Post body
      header: "", // Post title
    };
  },
  methods: {
    // Fetch the post when the page loads
    async fetchPost() {
      try {
        const response = await fetch(
          `http://localhost:3000/api/posts/${this.$route.params.id}`,
          {
            method: "GET",
          }
        );
        if (!response.ok) {
          throw new Error(`Failed to fetch post: ${response.status}`);
        }
        const data = await response.json();
        this.header = data.title;
        this.content = data.body;
      } catch (error) {
        console.error("Error fetching post:", error.message);
      }
    },

    // Update the post
    async updatePost() {
      try {
        const response = await fetch(
          `http://localhost:3000/api/posts/${this.$route.params.id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              title: this.header,
              body: this.content,
            }),
          }
        );
        if (!response.ok) {
          throw new Error("Failed to update post.");
        }
        alert("Postitus uuendatud!");
        this.$router.push("/");
      } catch (error) {
        alert("Postituse uuendamine ebaõnnestus.");
        console.error("Error updating post:", error.message);
      }
    },

    // Delete the post
    async deletePost() {
      if (!confirm("Kas soovid postituse kustutada?")) return;
      try {
        const response = await fetch(
          `http://localhost:3000/api/posts/${this.$route.params.id}`,
          {
            method: "DELETE",
          }
        );
        if (!response.ok) {
          throw new Error("Failed to delete post.");
        }
        alert("Postitus kustutatud!");
        this.$router.push("/");
      } catch (error) {
        alert("Postituse kustutamine ebaõnnestus.");
        console.error("Error deleting post:", error.message);
      }
    },

    // Check if user is authenticated
    checkAuthentication() {
      fetch("http://localhost:3000/auth/authenticate", {
        method: "GET",
        credentials: "include",
      })
        .then((response) => response.json())
        .then((data) => {
          if (!data.authenticated) {
            this.$router.push("/login");
          }
        })
        .catch((err) => {
          console.error("Error checking authentication:", err.message);
          this.$router.push("/login");
        });
    },
  },
  mounted() {
    this.checkAuthentication(); // Verify user authentication
    this.fetchPost(); // Fetch the specific post
  },
};
</script>

<style scoped></style>
